import * as React from 'react';
import Swiper from '../../containers/Swiper';

import('./CarouselStyles.scss')   


const LEFT:string = 'left';
const RIGHT:string = 'right';

class CarouselComposer extends React.Component<any, any> {

    // register timeout for autoplay-step to be able to clear it if no autoplay-prop on render
    autoplayTimeout:any = null;

    constructor( props:any ) {
        super( props );
    }

    // starts a timeout and change the content by calling change content index action with the new index
    initAutoplay( changeContentPause:number, futureIndex:number, callback:Function ) {
        this.autoplayTimeout = setTimeout(() => {
            clearTimeout( this.autoplayTimeout );
            callback( futureIndex );
        }, changeContentPause );
    }

    componentDidMount() {
        // get the name of all content children and return them to the gui reducer via action
        // after that the names are available for other components like the statistic name component
        const childrenNames = React.Children.map( this.props.children, ( child: any ) => {
            return {
                headline: child.props.displayHeadline,
                subtitle: child.props.displaySubtitle || ''
            }
        });
        
        this.props.setContentName( childrenNames );
    }

    render() {
        const nextIndex:number = calcNextIndex( RIGHT, this.props.contentIndex, React.Children.count( this.props.children ) - 1, this.props.loop );
        const prevIndex:number = calcNextIndex( LEFT, this.props.contentIndex, React.Children.count( this.props.children ) - 1, this.props.loop );

        // we need to swipe over the borders of our content array -
        // when we swipe next from the last element we need to show the first element again
        // vice versa we need to show the last element when we swipe back from the first element
        let switchOnTo: number = this.props.contentIndex == ( React.Children.count( this.props.children ) -1 ) ? 0 : nextIndex;
        let switchBackTo: number = this.props.contentIndex == 0 ? ( React.Children.count( this.props.children ) -1 ) : prevIndex;

        // clear autoplay timeout if autoplay is false
        if ( this.autoplayTimeout && !this.props.autoplay ) {
            clearTimeout( this.autoplayTimeout );
        }

        // if autoplay is true the automated content rotator (initAutoplay) will start a timeout.
        // if the timeout is reached the timeout will be cleared and the change content index action will be triggered
        // due to the fact, that the action change the current index the render method will be triggered again and also the autoplay
        if ( this.props.autoplay ) {
            this.initAutoplay(
                this.props.changeContentPause,
                switchOnTo,
                this.props.changeIndex
            );
        }

        return (
            <div className="carouselMainWrapper">
                <div className="carousel sr-cell">
                    <div className="carouselSwiperWrapper">
                        <Swiper lockXAxis   = { true }
                                swipeLeft   = { ( event: any ) => { this.props.changeIndex( switchOnTo) } }
                                swipeRight  = { ( event: any ) => { this.props.changeIndex( switchBackTo) } } >
                            { contentTemplate( this.props.children, this.props.contentIndex ) }
                        </ Swiper>
                    </div>
                    { controlTemplate( LEFT, switchBackTo, (index: number) => { 
                        this.props.changeIndex(index)
                        // when this buttons is clicked, the user wants to see a specific tab, lets stop automode too
                        this.props.stopAutomode()
                    } ) }
                    { controlTemplate( RIGHT, switchOnTo, (index: number) => {
                        this.props.changeIndex(index)
                        // when this buttons is clicked, the user wants to see a specific tab, lets stop automode too
                        this.props.stopAutomode()
                    } ) }
                </div>
                { pagerTemplate( this.props.children, this.props.contentIndex ) }
            </div>
        );
    }
}

// calculates the new index dpending of the direction; handles also the loop
const calcNextIndex = ( direction: string, index: number, max: number, loop: boolean = false ) => {
    const afterMin = loop ? max : 0;
    const afterMax = loop ? 0 : max;

    switch ( direction ) {
        case LEFT:
            return index <= 0 ? afterMin : index - 1;
        case RIGHT:
            return index >= max ? afterMax : index + 1;
        default:
            return index;
    }
};

// takes a boolean and returns a active string; is useful for css actions
const isActive = ( value: boolean ) => value ? 'active' : '';

// takes some arguments like direction and a callback to renders the dom of the control button
const controlTemplate = ( direction: string, futureIndex: number, clickHandler: Function ) => {
    return (
        <div
            onClick={ ( event ) => { clickHandler( futureIndex ) } }
            className={ `carouselControl ${direction}` } >
        </div>
    );
};

// renders the dom of the pager
const pagerTemplate = ( children: any, activeIndex: number ) => {
    return (
        <div className="carouselPager sr-align-center sr-cell">
            {
                children.map( ( child: any, index: number ) => 
                    <span className={ `${isActive( ( index === activeIndex ) )} bullet` } key={index} ></span>
                )
            }
        </div>
    );
};

//renders the dom of the content and the given children
const contentTemplate = (children:any, contentIndex:number) => {
    return (
        <div className="carouselContent" style={{width: `${children.length * 100}%`, left: `${contentIndex * -100}%`}}>
            {children.map( ( child: any, index: number ) => {
                return (
                <div key={index} style={{
              width: `${100 / children.length}%`,
              height: child.props.verticalStretch ? '100%' : 'auto'
            }}>{child}</div>
                    )
                } )}
        </div>
    );
};

const moveElement = (arr: any, from: number, to: number = 0) => {
    let cutOut = arr.splice(from, 1) [0];
    return arr.splice(to, 0, cutOut);
}

export default CarouselComposer;
